import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/streamservice",
    name: "streamservice",

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/StreamAvailibility.vue"),
  },
  {
    path: "/movie/:movieId",
    name: "movie",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/MovieDetail.vue"),
  },

  {
    path: "/search/:movieTitle",
    name: "search",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SearchMovie.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
